import React from 'react';
import {useTranslation} from 'react-i18next';
import {type Offer} from '@chekin/core';
import styles from './styles.module.css';
import {StatusModal, StatusModalStates} from '@chekin/shared';
import {ConfirmButton, SecondaryButton} from './styled';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  confirmationType: Offer['confirmation_type'];
  onGoToCart?: () => void;
  onContinue?: () => void;
};
function CreateDealCompleteModal({isOpen, onClose, onGoToCart, onContinue}: Props) {
  const {t} = useTranslation();

  return (
    <StatusModal state={StatusModalStates.SUCCESS} open={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.containerInformation}>
          <div className={styles.title}>
            {t('create_deal_complete_modal.auto_confirmation_type.message')}
          </div>
        </div>
        <div className={styles.containerButton}>
          <ConfirmButton label={t('my_cart')} onClick={() => onGoToCart?.()} />
          <SecondaryButton link label={t('continue')} onClick={() => onContinue?.()} />
        </div>
      </div>
    </StatusModal>
  );
}

export {CreateDealCompleteModal};
